import styled from 'styled-components';
export const Bold = styled.span.withConfig({
  displayName: "Bold",
  componentId: "sc-1j14ovk-0"
})(["font-weight:500;"]);
Bold.displayName = 'Bold';